import { NgIf, NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-panel',
    template: `
        <div
            class="flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full"
        >
            <!-- Titolo integrato nel bordo -->
            @if (props.label) {
                <div class="px-4 pt-3 pb-2 bg-white rounded-t-lg border-b">
                    <h3 class="flex justify-center items-center text-lg font-semibold text-gray-800 p-1">
                        {{ props.label }}
                    </h3>
                </div>
            }

            <!-- Contenuto del form -->
            <div class="p-4 md:p-5">
                <div class="grid grid-flow-col auto-cols-fit auto-rows-fit">
                    <ng-container #fieldComponent></ng-container>
                </div>
            </div>
        </div>
    `,
    standalone: true,
    imports: [FormlyModule],
})
export class GroupBorderPanel extends FieldWrapper {}
